import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=b8345d6a&scoped=true"
import script from "./SelectBox.vue?vue&type=script&lang=ts"
export * from "./SelectBox.vue?vue&type=script&lang=ts"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=b8345d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8345d6a",
  null
  
)

export default component.exports